import { FieldType, FieldTypeType } from "../../../services/helpers/types";
import AddBooleanField from "../../atoms/AddBoleanField/AddBooleanField";
import AddBooleanTextField from "../../atoms/AddBooleanTextField/AddBooleanTextField";
import AddButtonGroupField from "../../atoms/AddButtonGroupField/AddButtonGroupField";
import AddCascaderField from "../../atoms/AddCascaderField/AddCascaderField";
import AddMultiSelectField from "../../atoms/AddMultiSelectField/AddMultiSelectField";
import AddNumberField from "../../atoms/AddNumberField/AddNumberField";
import AddNumberNumberField from "../../atoms/AddNumberNumberField/AddNumberNumberField";
import AddSelectField from "../../atoms/AddSelectField/AddSelectField";
import AddStaticTextField from "../../atoms/AddStaticTextField/AddStaticTextField";
import AddTextField from "../../atoms/AddTextField/AddTextField";

export const addFieldRenderer = (
  type: FieldTypeType,
  onFieldChange: (name: string, value?: string, defaultValue?: string) => void,
  field?: FieldType,
) => {
  switch (type) {
    case FieldTypeType.Text: {
      return <AddTextField field={field} onFieldChange={onFieldChange} />;
    }
    case FieldTypeType.Number: {
      return <AddNumberField field={field} onFieldChange={onFieldChange} />;
    }
    case FieldTypeType.NumberNumber: {
      return (
        <AddNumberNumberField field={field} onFieldChange={onFieldChange} />
      );
    }
    case FieldTypeType.BMICalculator: {
      return (
        <AddNumberNumberField
          field={field}
          onFieldChange={onFieldChange}
          hideDefaults={true}
        />
      );
    }
    case FieldTypeType.BooleanText: {
      return (
        <AddBooleanTextField field={field} onFieldChange={onFieldChange} />
      );
    }
    case FieldTypeType.Select: {
      return <AddSelectField field={field} onFieldChange={onFieldChange} />;
    }
    case FieldTypeType.MultipleChoice: {
      return (
        <AddMultiSelectField field={field} onFieldChange={onFieldChange} />
      );
    }
    case FieldTypeType.ButtonGroup: {
      return (
        <AddButtonGroupField field={field} onFieldChange={onFieldChange} />
      );
    }
    case FieldTypeType.Boolean: {
      return <AddBooleanField field={field} onFieldChange={onFieldChange} />;
    }
    case FieldTypeType.Button:
    case FieldTypeType.StaticText: {
      return <AddStaticTextField field={field} onFieldChange={onFieldChange} />;
    }
    case FieldTypeType.Cascader: {
      return <AddCascaderField field={field} onFieldChange={onFieldChange} />;
    }
  }
};
